// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sa-answer-block {
  display: flex;
  flex-direction: column;
  padding: 8px 12px;
}
.sa-answer-block .sa-answer-header-block {
  margin-top: 8px;
}
.sa-answer-block .sa-answer-header-block .sa-answer-left {
  display: flex;
  gap: 7px;
}
.sa-answer-block .sa-answer-header-block .sa-answer-left .sa-answer-text {
  color: var(--Purple-700, #5925DC);
  font-size: 10px;
  font-weight: 500;
  line-height: 18px;
}
.sa-answer-block .sa-answer-result-block {
  gap: 8px;
  padding: 8px 16px 16px 16px;
  border-radius: 8px;
  border-top: 4px solid var(--Gray-100, #F2F4F7);
  background: var(--Base-White, #FFF);
  box-shadow: 0px 2px 4px -2px rgba(16, 24, 40, 0.06), 0px 4px 8px -2px rgba(16, 24, 40, 0.1);
  border-radius: 8px;
  background: linear-gradient(white, white) padding-box, linear-gradient(to right, #AD00FE, #00E0EE) border-box;
  border-top: 5px solid transparent;
}
.sa-answer-block .sa-answer-result-block .sa-tooltip-container {
  display: inline-block;
  position: relative;
}
.sa-answer-block .sa-answer-result-block .sa-tooltip {
  min-width: 200px;
  visibility: hidden;
  padding: 8px;
  font-family: Inter;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  color: #344054;
  background-color: #fff; /* White background for tooltip */
  border-radius: 8px;
  position: absolute;
  bottom: 125%; /* Position above the text */
  left: 50%;
  margin-left: -75px; /* Center the tooltip */
  opacity: 0;
  transition: opacity 0.3s;
  box-shadow: 0px 4px 8px -2px rgba(16, 24, 40, 0.08);
}
.sa-answer-block .sa-answer-result-block .sa-tooltip::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px; /* Center the arrow */
  border-width: 5px;
  border-style: solid;
  border-color: #fff transparent transparent transparent; /* White arrow */
}
.sa-answer-block .sa-answer-result-block .sa-tooltip-container:hover .sa-tooltip {
  visibility: visible;
  opacity: 1;
}
.sa-answer-block .sa-answer-result-block .sa-answer-result-sub-block {
  overflow: scroll;
}
.sa-answer-block .sa-answer-result-block .sa-answer-result-sub-block table {
  border: 1.4px solid gray;
  padding: 2px;
  border-collapse: collapse;
  border-radius: 4px;
}
.sa-answer-block .sa-answer-result-block .sa-answer-result-sub-block table tr td, .sa-answer-block .sa-answer-result-block .sa-answer-result-sub-block table tr th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}
.sa-answer-block .sa-answer-result-block .sa-answer-result-heading {
  color: var(--Gray-700, #344054);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  cursor: pointer;
}
.sa-answer-block .sa-answer-result-block .sa-answer-result-heading .sa-answer-list-item {
  padding: 0px 7px 0 1px;
  border: 1px solid #EAECF0;
  padding: 2px 4px;
  color: var(--Gray-400, #344054);
  border-radius: 9999px;
  font-family: Inter;
  font-size: 10px;
  font-weight: 500;
  line-height: 12px;
}
.sa-answer-block .sa-answer-result-block .sa-answer-result-heading .sa-answer-list-item-selected {
  color: #004EEB;
  border: 1px solid #B2CCFF;
}
.sa-answer-block .sa-answer-result-block .sa-answer-result-heading-selected {
  color: var(--Gray-700, #344054) !important;
  background-color: #EFF4FF;
}
.sa-answer-block .sa-answer-result-block .sa-answer-result-desc {
  color: var(--Gray-700, #344054);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}
.sa-answer-block .sa-answer-result-block .sa-answer-result-footer {
  border-radius: 4px;
  height: 20px;
  padding: 2px 8px;
  color: #344054;
  border: 1px solid #D0D5DD;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  gap: 6px;
}
.sa-answer-block .sa-answer-result-block .selected {
  color: #155EEF;
  border: 1px solid #B2CCFF;
  background-color: #EFF4FF;
}
.sa-answer-block .sa-answer-result-block .sa-answer-gen-footer {
  margin-top: 10px;
  gap: 4px;
  display: flex;
  flex-wrap: wrap;
}
.sa-answer-block .sa-answer-result-block .sa-answer-gen-footer .sa-answer-file-url-block {
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 6px;
  align-items: center;
  justify-content: center;
}
.sa-answer-block .sa-answer-result-block .sa-answer-gen-footer .sa-answer-file-url-block .sa-preview-text {
  display: none;
}
.sa-answer-block .sa-answer-result-block .sa-answer-gen-footer .sa-answer-file-url-block:hover .sa-answer-file-url-icon {
  background-color: #528BFF;
  color: #FFF;
  border: 1.3px solid #528BFF;
}
.sa-answer-block .sa-answer-result-block .sa-answer-gen-footer .sa-answer-file-url-block:hover .sa-preview-text {
  display: flex;
  font-size: 10px;
  font-weight: 500;
  line-height: 18px;
  color: #155EEF;
}
.sa-answer-block .sa-answer-result-block .sa-answer-gen-footer .sa-answer-file-url-block .sa-answer-file-url-icon {
  border: 1.3px solid #98A2B3;
  border-radius: 2px;
  font-size: 8px;
  padding: 6px 5px;
  line-height: 1px;
  font-weight: 600;
}
.sa-answer-block .sa-answer-result-block .sa-answer-feedback-block {
  margin-top: 8px;
}
.sa-answer-block .sa-answer-result-block .sa-answer-feedback-block .sa-answer-left {
  display: flex;
  gap: 7px;
}
.sa-answer-block .sa-answer-result-block .sa-answer-feedback-block .sa-answer-left .sa-answer-img {
  border-radius: 20px;
  background: var(--Purple-50, #F4F3FF);
  padding: 2px;
  display: flex;
  padding: 4px;
  justify-content: center;
  align-items: center;
  gap: 4px;
}
.sa-answer-block .sa-answer-result-block .sa-answer-feedback-block .sa-answer-left .sa-answer-text {
  color: var(--Purple-700, #5925DC);
  font-size: 8px;
  font-weight: 500;
  line-height: 18px;
}
.sa-answer-block .sa-answer-carousel-block {
  display: flex;
  justify-content: center;
  padding-top: 12px;
  gap: 10px;
}
.sa-answer-block .sa-answer-carousel-block .sa-answer-dot .m-b-5 {
  margin-bottom: 5px;
}
.sa-answer-block .sa-answer-carousel-block .sa-answer-count {
  display: flex;
  height: 16px;
  padding: 0px 6px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 12px;
  border: 1px solid var(--Gray-200, #EAECF0);
  color: var(--Gray-400, #98A2B3);
  font-size: 10px;
  font-weight: 500;
  line-height: 18px;
}
.sa-answer-block .sa-file-popup-img-container {
  position: relative;
}
.sa-answer-block .sa-file-popup-img-container .sa-file-popup-img {
  width: 100%;
  height: 133px;
  overflow: hidden;
  border-radius: 8px;
  border: 1px solid #98A2B3;
  position: absolute;
  top: -133px;
  left: 0px;
  padding-bottom: 0px !important;
  overflow-x: hidden;
}
.sa-answer-block .sa-file-popup-img-container .sa-file-popup-img.d-none {
  display: none !important;
}
.sa-answer-block .sa-file-popup-img-container .sa-file-popup-img img {
  width: 100%;
}
.sa-answer-block .pointer-events-none {
  pointer-events: none !important;
}
.sa-answer-block h1, .sa-answer-block h2, .sa-answer-block h3, .sa-answer-block h4, .sa-answer-block h5, .sa-answer-block h6 {
  margin-top: 8px !important;
  margin-bottom: 8px !important;
}`, "",{"version":3,"sources":["webpack://./src/plugins/answers/templates/answerTemplate/answerTemplate.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,iBAAA;AACJ;AAAI;EACI,eAAA;AAER;AAAQ;EACI,aAAA;EACA,QAAA;AAEZ;AAAY;EACI,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAEhB;AAII;EACI,QAAA;EACA,2BAAA;EACA,kBAAA;EACA,8CAAA;EACA,mCAAA;EACA,2FAAA;EACA,kBAAA;EACA,6GAAA;EACA,iCAAA;AAFR;AAGQ;EACI,qBAAA;EACA,kBAAA;AADZ;AAKU;EACE,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,sBAAA,EAAA,iCAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA,EAAA,4BAAA;EACA,SAAA;EACA,kBAAA,EAAA,uBAAA;EACA,UAAA;EACA,wBAAA;EACA,mDAAA;AAHZ;AAMU;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,iBAAA,EAAA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,sDAAA,EAAA,gBAAA;AAJZ;AAOU;EACE,mBAAA;EACA,UAAA;AALZ;AAQQ;EACI,gBAAA;AANZ;AAOY;EACI,wBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AALhB;AAOwB;EACI,yBAAA;EACA,gBAAA;EACA,YAAA;AAL5B;AAYQ;EACI,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AAVZ;AAWY;EACQ,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,+BAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AATpB;AAWgB;EACI,cAAA;EACA,yBAAA;AATpB;AAYQ;EACI,0CAAA;EACA,yBAAA;AAVZ;AAaQ;EACI,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAXZ;AAcQ;EACK,kBAAA;EACD,YAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,QAAA;AAZZ;AAcQ;EACI,cAAA;EACA,yBAAA;EACA,yBAAA;AAZZ;AAcQ;EACI,gBAAA;EACA,QAAA;EACA,aAAA;EACA,eAAA;AAZZ;AAaY;EACQ,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,uBAAA;AAXpB;AAYoB;EACI,aAAA;AAVxB;AAawB;EACI,yBAAA;EACA,WAAA;EACA,2BAAA;AAX5B;AAawB;EACI,aAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAX5B;AAegB;EACI,2BAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAbpB;AAkBQ;EACI,eAAA;AAhBZ;AAkBY;EACI,aAAA;EACA,QAAA;AAhBhB;AAkBgB;EACI,mBAAA;EACA,qCAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AAhBpB;AAkBgB;EACI,iCAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AAhBpB;AAuBI;EACI,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,SAAA;AArBR;AAwBY;EACI,kBAAA;AAtBhB;AA0BQ;EACI,aAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,0CAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAxBZ;AA2BI;EACI,kBAAA;AAzBR;AA0BQ;EACI,WAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,8BAAA;EACA,kBAAA;AAxBZ;AAyBY;EACI,wBAAA;AAvBhB;AAyBY;EACI,WAAA;AAvBhB;AA2BI;EACI,+BAAA;AAzBR;AA2BI;EACI,0BAAA;EACA,6BAAA;AAzBR","sourcesContent":[".sa-answer-block {\n    display: flex;\n    flex-direction: column;\n    padding: 8px 12px;\n    .sa-answer-header-block {\n        margin-top: 8px;\n\n        .sa-answer-left {\n            display: flex;\n            gap: 7px;\n\n            .sa-answer-text {\n                color: var(--Purple-700, #5925DC);\n                font-size: 10px;\n                font-weight: 500;\n                line-height: 18px;\n            }\n        }\n    }\n\n\n    .sa-answer-result-block {\n        gap: 8px;\n        padding: 8px 16px 16px 16px;\n        border-radius: 8px;\n        border-top: 4px solid var(--Gray-100, #F2F4F7);\n        background: var(--Base-White, #FFF);\n        box-shadow: 0px 2px 4px -2px rgba(16, 24, 40, 0.06), 0px 4px 8px -2px rgba(16, 24, 40, 0.10);\n        border-radius: 8px;\n        background: linear-gradient(white, white) padding-box, linear-gradient(to right, #AD00FE, #00E0EE) border-box;\n        border-top: 5px solid transparent;\n        .sa-tooltip-container {\n            display: inline-block;\n            position: relative;\n          }\n      \n      \n          .sa-tooltip{\n            min-width:200px;\n            visibility: hidden;\n            padding:8px;\n            font-family:Inter;\n            font-weight:500;\n            font-size:12px;\n            line-height: 18px;\n            color:#344054;\n            background-color: #fff; /* White background for tooltip */\n            border-radius: 8px;\n            position: absolute;\n            bottom: 125%; /* Position above the text */\n            left: 50%;\n            margin-left: -75px; /* Center the tooltip */\n            opacity: 0;\n            transition: opacity 0.3s;\n            box-shadow: 0px 4px 8px -2px rgba(16, 24, 40, 0.08);\n        }\n      \n          .sa-tooltip::after {\n            content: '';\n            position: absolute;\n            top: 100%;\n            left: 50%;\n            margin-left: -5px; /* Center the arrow */\n            border-width: 5px;\n            border-style: solid;\n            border-color: #fff transparent transparent transparent; /* White arrow */\n          }\n      \n          .sa-tooltip-container:hover .sa-tooltip {\n            visibility: visible;\n            opacity: 1;\n          }\n          \n        .sa-answer-result-sub-block {\n            overflow: scroll;\n            table{\n                border: 1.4px solid gray;\n                padding: 2px;\n                border-collapse: collapse;\n                border-radius: 4px;\n                    tr{\n                        td,th{\n                            border: 1px solid #dddddd;\n                            text-align: left;\n                            padding: 8px;\n                        }\n                    }\n\n            }\n        }        \n\n        .sa-answer-result-heading {\n            color: var(--Gray-700, #344054);\n            font-size: 14px;\n            font-weight: 400;\n            line-height: 20px;\n            cursor: pointer;        \n            .sa-answer-list-item{\n                    padding: 0px 7px 0 1px;\n                    border:1px solid #EAECF0;\n                    padding:2px 4px;\n                    color: var(--Gray-400, #344054);\n                    border-radius:9999px;\n                    font-family: Inter;\n                    font-size: 10px;\n                    font-weight: 500;\n                    line-height: 12px;\n                }\n                .sa-answer-list-item-selected{\n                    color:#004EEB;\n                    border:1px solid #B2CCFF;\n                }\n        }\n        .sa-answer-result-heading-selected {\n            color: var(--Gray-700, #344054) !important;\n            background-color: #EFF4FF;\n        }   \n\n        .sa-answer-result-desc {\n            color: var(--Gray-700, #344054);\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 18px;\n        }\n\n        .sa-answer-result-footer {\n             border-radius: 4px;\n            height: 20px;\n            padding: 2px 8px;\n            color:#344054;\n            border:1px solid #D0D5DD;\n            font-size: 12px;\n            font-weight: 500;\n            line-height: 16px;\n            cursor: pointer;\n            display: flex;\n            gap:6px;\n        }\n        .selected {\n            color: #155EEF;\n            border: 1px solid #B2CCFF;\n            background-color: #EFF4FF;\n        }\n        .sa-answer-gen-footer {\n            margin-top: 10px;\n            gap:4px;\n            display: flex;\n            flex-wrap: wrap;\n            .sa-answer-file-url-block{\n                    display:flex;\n                    justify-content: start;\n                    align-items: center;\n                    gap: 6px;\n                    align-items: center;\n                    justify-content: center;\n                    .sa-preview-text{\n                        display: none;\n                    }\n                    &:hover{\n                        .sa-answer-file-url-icon{\n                            background-color: #528BFF;\n                            color: #FFF;\n                            border: 1.3px solid #528BFF;\n                        }\n                        .sa-preview-text{\n                            display: flex;\n                            font-size: 10px;\n                            font-weight: 500;\n                            line-height: 18px;\n                            color: #155EEF;\n                        }\n                     \n                    }\n                .sa-answer-file-url-icon {\n                    border: 1.3px solid #98A2B3;\n                    border-radius: 2px;\n                    font-size: 8px;\n                    padding: 6px 5px;\n                    line-height: 1px;\n                    font-weight: 600;\n                }\n            }\n        }\n\n        .sa-answer-feedback-block {\n            margin-top: 8px;\n\n            .sa-answer-left {\n                display: flex;\n                gap: 7px;\n\n                .sa-answer-img {\n                    border-radius: 20px;\n                    background: var(--Purple-50, #F4F3FF);\n                    padding: 2px;\n                    display: flex;\n                    padding: 4px;\n                    justify-content: center;\n                    align-items: center;\n                    gap: 4px;\n                }\n                .sa-answer-text {\n                    color: var(--Purple-700, #5925DC);\n                    font-size: 8px;\n                    font-weight: 500;\n                    line-height: 18px;\n                }\n            }\n        }\n\n    }\n\n    .sa-answer-carousel-block {\n        display: flex;\n        justify-content: center;\n        padding-top: 12px;\n        gap: 10px;\n\n        .sa-answer-dot {\n            .m-b-5 {\n                margin-bottom: 5px;\n            }\n        }\n\n        .sa-answer-count {\n            display: flex;\n            height: 16px;\n            padding: 0px 6px;\n            justify-content: center;\n            align-items: center;\n            gap: 4px;\n            border-radius: 12px;\n            border: 1px solid var(--Gray-200, #EAECF0);\n            color: var(--Gray-400, #98A2B3);\n            font-size: 10px;\n            font-weight: 500;\n            line-height: 18px;\n        }\n    }\n    .sa-file-popup-img-container{\n        position: relative;\n        .sa-file-popup-img{\n            width: 100%;\n            height: 133px;\n            overflow: hidden;\n            border-radius: 8px;\n            border: 1px solid #98A2B3;\n            position: absolute;\n            top: -133px;\n            left: 0px;\n            padding-bottom: 0px !important;\n            overflow-x: hidden;\n            &.d-none{\n                display: none !important;\n            }\n            img{\n                width: 100%;\n            }\n        }\n    }\n    .pointer-events-none{\n        pointer-events: none !important;\n    }\n    h1, h2, h3, h4, h5, h6 {\n        margin-top: 8px !important;\n        margin-bottom: 8px !important;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
